import { useQuery } from '@tanstack/react-query';
import { getPngQrCodeForUrl } from '@services/qrCodeService';

export const useGetPngQrCodeForUrl = (
  url: string,
  scale: string,
  enabled: boolean = false,
) => {

  const { data, isFetching, refetch } = useQuery(
    ['getPngQrCodeForUrl', url, scale],
    () => getPngQrCodeForUrl(url, scale),
    {
      enabled,
    },
  );

  return { data, isFetching: isFetching, refetch };
};
